import './App.css';
import ImageSlider from "./components/ImageSlider";
import { SliderData } from "./components/SliderData"

function App() {
  return (
    <div style={{width: "100%", height: "auto", maxWidth: "100%", alignItems: "center", display: "block", padding: "30px", backgroundColor: "black"}}>
      <ImageSlider slides={SliderData}/>
    </div>
  );
}

export default App;